import { Toast, ToastViewport } from "@app/ui";
import { useToastStore } from "../../stores/index.js";

/** Renders the live toast stack. Mount once in the app shell. */
export function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  return (
    <ToastViewport>
      {toasts.map((t) => (
        <Toast key={t.id} tone={t.tone} message={t.message} action={t.action} onDismiss={() => dismiss(t.id)} />
      ))}
    </ToastViewport>
  );
}
